import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { OnChanges, SimpleChanges } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { BusinessService } from '@App/common/services';
import { NotificationService } from '@Shared/services';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-pitchcard-resume-modal',
  standalone: true,

  imports: [CommonModule, DialogModule, NgxDocViewerModule],
  templateUrl: './pitchcard-resume-modal.component.html'
})
export class PitchCardResumeModalComponent
  extends PitchCardModalBase
  implements OnChanges
{
  @Input() showResumeFileDialog: any;
  @Input() currentPitchCard: any;
  @Input() isTablet: any;
  @Input() isSearch: any;

  resumeFileExtension = '';
  private businessService = inject(BusinessService);
  private notificationService = inject(NotificationService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showResumeFileDialog']?.currentValue === true) {
      this.getResumeFileExtension();
    }
  }

  downloadResume(event: Event) {
    event.preventDefault();

    const url = this.currentPitchCard?.resumeFileUrl;
    if (!url) {
      return;
    }

    const pathname = new URL(url, window.location.origin).pathname;
    const extension = pathname.match(/\.([a-z0-9]+)$/i)?.[1];
    const filename = extension ? `resume.${extension}` : 'resume';

    this.businessService.downloadImageBlob(url).subscribe({
      next: (blob: Blob) => {
        saveAs(blob, filename);
      },
      error: () => {
        this.notificationService.showNotification(
          'ERROR',
          'Unable to download the resume. Please try again.'
        );
      }
    });
  }

  showViaDocViewer() {
    return (
      this.resumeFileExtension === 'pdf' ||
      this.resumeFileExtension === 'doc' ||
      this.resumeFileExtension === 'docx'
    );
  }

  getResumeFileExtension() {
    this.resumeFileExtension = this.currentPitchCard?.resumeFileUrl
      ? this.currentPitchCard?.resumeFileUrl.split('.').pop()
      : '';
  }
}
